import {
    AfterViewInit,
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ElementRef,
    EventEmitter,
    Input,
    OnInit,
    Output,
    TemplateRef,
    ViewChild,
} from "@angular/core";
import { Compbaser } from "../compbaser";
import { ActivatedRoute, Router } from "@angular/router";
import {
    EnumStudioType,
    ExperienceLevelType,
    IAppStatic,
    Id,
    IPlayerProps,
    IResource,
    ISceneBlock,
    IUser,
} from "../../interfaces";
import {
    faCalendarCheck,
    faCertificate,
    faImage,
    faLayerGroup,
    faLocationCrosshairs,
    faMinusCircle,
    faPhotoFilm,
    faPlusCircle,
    faPuzzlePiece,
} from "@fortawesome/free-solid-svg-icons";
import {
    AccessService,
    AppService,
    AuthUserService,
    ContainerService,
    LocalStoreService,
    StoreSelectorsService,
} from "../../services";
import { delay, filter, map, startWith, switchMap, tap } from "rxjs/operators";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { actionNetworkRequest, actionSelfUpgradeEligibleRequest } from "../../store/actions/user.actions";
import { ofType } from "@ngrx/effects";
import { ActionsSubject } from "@ngrx/store";
import { TranslocoService } from "@ngneat/transloco";
import { ToastrService } from "ngx-toastr";
import { DEV_TEST_PORT, isHostDev, isHostDevOrLocal, isNullOrUndef, popupWindow } from "../../common";
import { combineLatest, Observable } from "rxjs";
import { animate, style, transition, trigger } from "@angular/animations";
import { Lib } from "../../../libs/Lib";
import { MatAccordion } from "@angular/material/expansion";
import { TwitterComponent } from "../twitter/twitter.component";
import {
    SceneAddComponentDialog,
} from "../../containers/editor/scene-add-block/scene-add-component-dialog/scene-add-component-dialog";

@Component({
    selector: "app-nav",
    styleUrls: [`./nav.component.scss`, `./nav-theme-dialog.scss`],
    templateUrl: "./nav.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: [
        trigger("grow", [
            transition(":enter", [
                // :enter is alias to 'void => *'
                style({ height: "0", overflow: "hidden" }),
                animate(500, style({ height: "*" })),
            ]),
            transition(":leave", [
                // :leave is alias to '* => void'
                animate(500, style({ height: 0, overflow: "hidden" })),
            ]),
        ]),
    ],
    standalone: false,
})


export class NavComponent extends Compbaser implements AfterViewInit, OnInit {

    @Input() minimized = false;
    @Output() whenMinimized: EventEmitter<any> = new EventEmitter();
    @Output() whenMaximized: EventEmitter<any> = new EventEmitter();
    @Output() whenClosed: EventEmitter<any> = new EventEmitter();
    @Output() routerClick: EventEmitter<any> = new EventEmitter();

    @ViewChild("networkStatusModal", { read: TemplateRef }) networkStatusModal: TemplateRef<any>;
    @ViewChild("themeDialogModal", { read: TemplateRef }) themeDialogModal: TemplateRef<any>;
    @ViewChild(MatAccordion) accordion: MatAccordion;

    activeSceneId: Id;
    networkCall = false;
    user: IUser;
    enableDynawebs = false;
    enterpriseMode: boolean;
    dashboardMode: boolean;
    upgradable: boolean;
    selected = "domain";
    appStatic: IAppStatic;
    fasterqEnabled = "0";
    showHelpEnabled = "0";
    eventsEnabled = "0";
    scheduledEnabled = "0";
    dashboardEnabled = "0";
    paintEnabled = "0";
    enableDashboard = "0";
    catalogEnabled = "0";
    transitionsEnabled = "0";
    musicEnabled = "0";
    iotEnabled = "1";
    pinnedModules = new Set<string>();
    liveChatStatus = false;
    studioType: EnumStudioType;
    addSceneItem: ISceneBlock;
    selectedSceneId;
    sceneData: IPlayerProps;
    resources: IResource[] = [];
    isMimeMainPlayer = false;
    spun = 0;
    activePanel = 0;
    isFullFeatures: boolean;

    // Dev-only API port reminder shown on the main toolbar. isHostDevOrLocal() is false in
    // production / galaxy, so this is never rendered there. devPort is 443 unless the developer
    // opted into the dev C# server (9443) via settings.
    showDevPort = isHostDevOrLocal();
    devPort = DEV_TEST_PORT;

    navMain$: Observable<string>;
    navEnterprise$: Observable<string>;
    navUser$: Observable<string>;
    navChat$: Observable<string>;
    navSearch$: Observable<string>;

    signStudioDashboard$: Observable<string>;
    signStudioEditor$: Observable<string>;
    signStudioResources$: Observable<string>;
    signStudioProducts$: Observable<string>;
    signStudioDownloads$: Observable<string>;
    signStudioHelp$: Observable<string>;
    signStudioPlayers$: Observable<string>;
    signStudioPainter$: Observable<string>;
    signStudioScheduler$: Observable<string>;
    signStudioFasterQ$: Observable<string>;
    signStudioMusic$: Observable<string>;
    signStudioCatalog$: Observable<string>;
    signStudioEvents$: Observable<string>;
    signStudioTransitions$: Observable<string>;
    signStudioAdnet$: Observable<string>;
    signStudioSettings$: Observable<string>;
    showAccount = true;

    EnumStudioType = EnumStudioType;
    readonly faPlusCircle = faPlusCircle;
    readonly faMinusCircle = faMinusCircle;
    readonly faLayerGroup = faLayerGroup;
    readonly faPuzzlePiece = faPuzzlePiece;
    readonly faLocationCrosshairs = faLocationCrosshairs;
    readonly faPhotoFilm = faPhotoFilm;
    readonly faCalendarCheck = faCalendarCheck;
    readonly faCertificate = faCertificate;
    readonly faImage = faImage;
    // readonly faCube = faCube;
    // readonly faSitemap = faSitemap;
    // readonly faTachometerAlt = faTachometerAlt;
    // readonly faIndent = faIndent;

    private scriptAttr: string | any = "twttr";


    dialogCompAddRef: MatDialogRef<SceneAddComponentDialog>;
    themeDialogRef: MatDialogRef<any>;
    readonly experienceLevelType = ExperienceLevelType; // Expose enum to template
    experienceLevel: ExperienceLevelType;
    currentTheme = "0";
    // canShowHelp = true;
    // AI gradient line animation state for nav clicks
    navLineAnimating = false;

    constructor(private router: Router,
                private storeSelector: StoreSelectorsService,
                private route: ActivatedRoute,
                private authUserService: AuthUserService,
                private actionsSubj: ActionsSubject,
                private translocoService: TranslocoService,
                private toastr: ToastrService,
                private localStoreService: LocalStoreService,
                private cd: ChangeDetectorRef,
                private accessService: AccessService,
                public override dialog: MatDialog,
                private appService: AppService,
                private element: ElementRef,
                private containerService: ContainerService,
    ) {
        super();

        // this.accessService.getGroupsCollection("SignStudio Dashboard").pipe(map((value) => value && value.$.navChat ? value.$.navChat : '1'))
        //     .subscribe((v) => {
        //         console.log(v);
        // });
        // this.accessService.getGroupsCollection("SignStudio Dashboard").pipe(map((value) => value && value.$.navSearch ? value.$.navSearch : '1'))
        //     .subscribe((v) => {
        //         console.log(v);
        // });

        // todo: when in slider mode we can hide navigation all together...
        // this.switchToSlideerMode();

        this.cod(
            this.actionsSubj.pipe(ofType(actionNetworkRequest))
                .pipe(
                    delay((111)),
                    tap(val => {
                        this.networkCall = true;
                        this.cd.markForCheck();
                    }),
                    delay((1111)),
                    tap(val => {
                        this.networkCall = false;
                        this.cd.markForCheck();
                    }),
                )
                .subscribe((reply) => {
                }),
        );
        this.cod(
            this.storeSelector.listenSelectedSceneId().subscribe((_sceneId: Id) => {
                const previousSceneId = this.activeSceneId;
                this.activeSceneId = _sceneId;

                // Auto-minimize menu bar when scene is selected
                if (_sceneId && !this.minimized) {
                    this.onMinimized();
                }

                // Auto-maximize menu bar when scene is deselected
                if (previousSceneId && !_sceneId && this.minimized) {
                    this.onMaximized();
                }
            }),
        );
        this.cod(
            this.storeSelector.getUser().subscribe((i_user) => {
                this.studioType = i_user.studioType;
            }),
        );
        this.cod(
            this.storeSelector.getLiveChatStatusV2().subscribe((i_status) => {
                if (i_status.liveStatusV2 > 0 !== this.liveChatStatus) this.cd.markForCheck();
                this.liveChatStatus = i_status.liveStatusV2 > 0;
            }),
        );
        this.cod(
            this.storeSelector.getLocalStoreUpdates()
                .subscribe((updates) => {
                    this.fasterqEnabled = this.localStoreService.getStorageValConfig("fasterqEnabled");
                    this.showHelpEnabled = this.localStoreService.getStorageValConfig("showHelpEnabled");
                    this.catalogEnabled = this.localStoreService.getStorageValConfig("catalogEnabled");
                    this.eventsEnabled = this.localStoreService.getStorageValConfig("eventsEnabled");
                    this.scheduledEnabled = this.localStoreService.getStorageValConfig("scheduledEnabled");
                    this.dashboardEnabled = this.localStoreService.getStorageValConfig("dashboardEnabled");
                    this.paintEnabled = this.localStoreService.getStorageValConfig("paintEnabled");
                    this.enableDashboard = this.localStoreService.getStorageValConfig("enableDashboard");
                    this.transitionsEnabled = this.localStoreService.getStorageValConfig("transitionsEnabled");
                    this.musicEnabled = this.localStoreService.getStorageValConfig("musicEnabled");
                    this.iotEnabled = this.localStoreService.getStorageValConfig("iotEnabled") ?? "1";
                    const pm = this.localStoreService.getStorageValConfig('pinnedModules') || '';
                    this.pinnedModules = new Set(pm.split(',').filter(Boolean));
                    this.cd.markForCheck();
                }),
        );
        this.cod(
            this.storeSelector.getLocalStoreUpdates()
                .subscribe((updates) => {
                }),
        );
        this.cod(
            this.storeSelector.isFullFeatures().subscribe((v) => {
                this.isFullFeatures = v;
            }),
        );
        this.cod(
            this.storeSelector.getUser().pipe(
                switchMap((i_user: IUser) => {
                    this.user = i_user;
                    this.enableDynawebs = i_user.username.indexOf("@mediasignage.com") > -1;
                    this.enterpriseMode = i_user.enterprise;
                    this.dashboardMode = i_user.dashboard;
                    this.upgradable = Lib.IsAccountUpgradable2(i_user);  // Alon test

                    // Lazily confirm reseller self-upgrade eligibility (server: accountStatusReseller != 4 AND
                    // reseller lapsed > 6 months). The reply sets selectedUser.canSelfUpgrade, which lights the
                    // upgrade rocket via IsAccountUpgradable/2. Guarded on undefined so it fires once.
                    if (i_user.enterprise && !i_user.dashboard && !Lib.IsResellerStatusActive(i_user)
                        && i_user.canSelfUpgrade === undefined && i_user.businessId != null) {
                        this.storeSelector.dispatch(actionSelfUpgradeEligibleRequest({businessId: String(i_user.businessId)}));
                    }

                    // Alon added that untill we support WL
                    // const accountVersion = Lib.GetAccountVersion(i_user);
                    // this.canShowHelp = (accountVersion == "FREE" || accountVersion == "PLUS" || accountVersion == "DASH");

                    // getLocalStoreUpdates("ILocalStorageConfig") only emits when the CURRENT
                    // localStorageUpdates.latestEvent === "ILocalStorageConfig". If the last localStore
                    // dispatch before nav mounted was any other type, this never fires on load and
                    // experienceLevel stays undefined — so the advanced sidebar items stay hidden until an
                    // unrelated config change (e.g. toggling the header mode). startWith forces one emission
                    // as soon as the user resolves (dashboardMode already set above), so experienceLevel is
                    // read on load; later "ILocalStorageConfig" updates still flow through. (Mirrors the
                    // fix in scene-editor.component.ts.)
                    return this.storeSelector.getLocalStoreUpdates("ILocalStorageConfig").pipe(startWith(null));

                }),
            ).subscribe((e) => {
                this.experienceLevel = this.dashboardMode ? ExperienceLevelType.ADVANCED : this.localStoreService.getStorageValConfig("experienceLevel"); // Alon
                const pm = this.localStoreService.getStorageValConfig('pinnedModules') || '';
                this.pinnedModules = new Set(pm.split(',').filter(Boolean));

                const intermediateUrlMap = {
                    "/paint/list": "paintEnabled",
                    "/catalog/list": "catalogEnabled",
                    "/scheduler/editor": "scheduledEnabled",
                    "/statistics": "dashboardEnabled",
                    "/download": null
                };
                const currentUrl = this.router.url;
                if (currentUrl in intermediateUrlMap && this.experienceLevel == ExperienceLevelType.BEGINNER) {
                    const moduleKey = intermediateUrlMap[currentUrl];
                    if (!moduleKey || !this.isPinned(moduleKey)) {
                        this.router.navigate(["/home"]);
                    }
                }

                const advancedUrlMap = {
                    "/events/list": "eventsEnabled",
                    "/transitions/list": "transitionsEnabled",
                    "/music/list": "musicEnabled",
                    "/fasterq/list": "fasterqEnabled"
                };
                if (currentUrl in advancedUrlMap && this.experienceLevel < ExperienceLevelType.ADVANCED) {
                    const moduleKey = advancedUrlMap[currentUrl];
                    if (!this.isPinned(moduleKey)) {
                        this.router.navigate(["/home"]);
                    }
                }
                this.cd.markForCheck();
            }),
        );
        this.cod(
            this.storeSelector.getAppSettings()
                .subscribe((i_appSettings: IAppStatic) => {
                    this.appStatic = i_appSettings;
                }),
        );

    }

    isPinned(key: string): boolean {
        return this.pinnedModules.has(key);
    }

    private switchToSlideerMode() {
        this.router.navigate(["/editor/touch/list"]);
        setTimeout(() => {
            this.whenClosed.emit();
        }, 10);
    }

    logout(): void {
        if (this.activeSceneId) {
            this.appService.updateMultiScene([this.activeSceneId], true);
            setTimeout(() => {
                this.authUserService.logout();
                this.appService.goToHomePage(false);
            }, 3000);
        } else {
            setTimeout(() => {
                this.authUserService.logout();
                this.appService.goToHomePage(false);
            }, 1000);
        }
    }

    ngOnInit(): void {
        /* Alon
        this.cod(
            combineLatest([this.storeSelector.listenSelectedSceneId(), this.storeSelector.listenScenes()])
                .pipe(
                    filter((v: any) => {
                        if (!isNullOrUndef(v[0]) && v[1].length) {
                            if (this.m_currentViewMode != 'scene') {
                                this.whenMaximized.emit();
                            }
                            this.m_currentViewMode = 'scene';
                            return true;
                        } else {
                            if (this.m_currentViewMode != 'nav') {
                                this.whenMaximized.emit();
                                this.activePanel = 0;
                            }
                            this.m_currentViewMode = 'nav';
                            return false;
                        }
                    }),
                    map(([sceneId, i_scenes]) => {
                        return i_scenes.find((i_scene: IPlayerProps) => {
                            if (i_scene.Player.$.id === sceneId) {
                                return true;
                            }
                        });
                    }))
                .subscribe((i_scene: IPlayerProps) => {
                    if (!i_scene) return;
                    this.sceneData = i_scene;
                    this.selectedSceneId = i_scene.Player.$.id;
                    this.isMimeMainPlayer = this.storeSelector.isMainSceneOrPlayer(i_scene.Player.$.mimeType);
                })
        );

         */

        this.cod(
            this.storeSelector.getResources().subscribe((i_resources) => {
                this.resources = i_resources;
            }),
        );

        // Initialize and listen to theme changes
        this.currentTheme = this.localStoreService.getStorageValConfig("theme") || "0";
        this.cod(
            this.localStoreService.theme.subscribe(() => {
                this.currentTheme = this.localStoreService.getStorageValConfig("theme") || "0";
                this.cd.markForCheck();
            }),
        );
    }

    ngAfterViewInit() {
        this.initAccess();
    }

    private initAccess() {
        this.accessService.getGroupsCollection("SignStudio Account")
            .pipe(map((value) => {
                return !(this.enterpriseMode && value?.$?.visible === "0");
            }))
            .subscribe((v) => {
                this.showAccount = v;
            });

        this.navMain$ = this.accessService.getGroupsCollection("SignStudio Dashboard").pipe(map((value) => value && value.$.navMain ? value.$.navMain : "1"));
        this.navUser$ = this.accessService.getGroupsCollection("SignStudio Dashboard").pipe(map((value) => value && value.$.navUser ? value.$.navUser : "1"));
        this.navChat$ = this.accessService.getGroupsCollection("SignStudio Dashboard").pipe(map((value) => value && value.$.navChat ? value.$.navChat : "1"));
        this.navSearch$ = this.accessService.getGroupsCollection("SignStudio Dashboard").pipe(map((value) => value && value.$.navSearch ? value.$.navSearch : "1"));
        this.navEnterprise$ = this.accessService.getGroupsCollection("SignStudio Dashboard").pipe(map((value) => value && value.$.navEnterprise ? value.$.navEnterprise : "1"));
        this.signStudioEditor$ = this.accessService.getGroupsCollection("SignStudio Editor").pipe(map((value) => value && value.$.visible ? value.$.visible : "1"));
        this.signStudioDashboard$ = this.accessService.getGroupsCollection("SignStudio Dashboard").pipe(map((value) => value && value.$.visible ? value.$.visible : "1"));
        this.signStudioResources$ = this.accessService.getGroupsCollection("SignStudio Resources").pipe(map((value) => value && value.$.visible ? value.$.visible : "1"));
        this.signStudioHelp$ = this.accessService.getGroupsCollection("SignStudio Help").pipe(map((value) => value && value.$.visible ? value.$.visible : "1"));
        this.signStudioDownloads$ = this.accessService.getGroupsCollection("SignStudio Downloads").pipe(map((value) => value && value.$.visible ? value.$.visible : "1"));
        this.signStudioProducts$ = this.accessService.getGroupsCollection("SignStudio Dashboard").pipe(map((value) => value && value.$.navProducts ? value.$.navProducts : "1"));
        this.signStudioPlayers$ = this.accessService.getGroupsCollection("SignStudio Players").pipe(map((value) => value && value.$.visible ? value.$.visible : "1"));
        this.signStudioPainter$ = this.accessService.getGroupsCollection("SignStudio Painter").pipe(map((value) => value && value.$.visible ? value.$.visible : "1"));
        this.signStudioScheduler$ = this.accessService.getGroupsCollection("SignStudio Scheduler").pipe(map((value) => value && value.$.visible ? value.$.visible : "1"));
        this.signStudioFasterQ$ = this.accessService.getGroupsCollection("SignStudio FasterQ").pipe(map((value) => value && value.$.visible ? value.$.visible : "1"));
        this.signStudioMusic$ = this.accessService.getGroupsCollection("SignStudio Music").pipe(map((value) => value && value.$.visible ? value.$.visible : "1"));
        this.signStudioSettings$ = this.accessService.getGroupsCollection("SignStudio Settings").pipe(map((value) => value && value.$.visible ? value.$.visible : "1"));
        this.signStudioCatalog$ = this.accessService.getGroupsCollection("SignStudio Catalog").pipe(map((value) => value && value.$.visible ? value.$.visible : "1"));
        this.signStudioEvents$ = this.accessService.getGroupsCollection("SignStudio Events").pipe(map((value) => value && value.$.visible ? value.$.visible : "1"));
        this.signStudioTransitions$ = this.accessService.getGroupsCollection("SignStudio Transitions").pipe(map((value) => value && value.$.visible ? value.$.visible : "1"));
        this.signStudioAdnet$ = this.accessService.getGroupsCollection("SignStudio Adnet").pipe(map((value) => value && value.$.visible ? value.$.visible : "1"));

        // this.signStudioAccount$ = this.accessService.getGroupsCollection("SignStudio Account").pipe(map((value) => value && value.$.visible ? value.$.visible : '1'));
        // this.accessService.getGroupsCollection("SignStudio Downloads")
        //     .pipe(map((value) => {
        //         alert(value);
        //         return value && value.$.visible ? value.$.visible : '1';
        //     }))
        //     .subscribe((v) => {
        //     });
    }

    selectTheme(themeValue: string) {
        this.localStoreService.setStorageValConfig("theme", themeValue);
    }

    openThemeDialog() {
        this.themeDialogRef = this.dialog.open(this.themeDialogModal, {
            width: "800px",
            maxWidth: "90vw",
            panelClass: ["theme-selector-dialog", this.currentTheme === "2" ? "gradient-theme-dialog" : ""],
        });

        // Ensure proper class management after dialog opens
        setTimeout(() => {
            this.updateDialogThemeClasses(this.currentTheme);
        }, 50);
    }

    selectThemeFromDialog(themeValue: string) {
        this.selectTheme(themeValue);

        // Close and reopen dialog to force theme refresh
        if (this.themeDialogRef) {
            this.themeDialogRef.close();
            // Reopen after a brief delay to allow theme to apply
            setTimeout(() => {
                this.openThemeDialog();
            }, 150);
        }
    }

    private updateDialogThemeClasses(themeValue: string) {
        if (!this.themeDialogRef) return;

        // Update the dialog's panelClass directly via the config
        const config = this.themeDialogRef["_containerInstance"]?._config;
        if (config) {
            // Reset panelClass array
            config.panelClass = ["theme-selector-dialog"];

            // Add gradient class if deep night theme
            if (themeValue === "2") {
                config.panelClass.push("gradient-theme-dialog");
            }
        }

        // Also manually update DOM elements for immediate effect
        setTimeout(() => {
            const overlayRef = this.themeDialogRef?.["_overlayRef"];
            if (!overlayRef) return;

            const hostElement = overlayRef.hostElement;
            const overlayElement = overlayRef.overlayElement;

            if (!hostElement || !overlayElement) return;

            // Get dialog containers
            const dialogContainer = overlayElement.querySelector(".mat-mdc-dialog-container") as HTMLElement;
            const dialogSurface = overlayElement.querySelector(".mat-mdc-dialog-surface") as HTMLElement;

            // Remove all theme classes from all elements
            [hostElement, dialogContainer, dialogSurface].forEach(el => {
                if (el) {
                    el.classList.remove("gradient-theme-dialog");
                }
            });

            // Apply gradient theme
            if (themeValue === "2") {
                [hostElement, dialogContainer, dialogSurface].forEach(el => {
                    if (el) {
                        el.classList.add("gradient-theme-dialog");
                    }
                });

                // FORCE inline styles as backup
                if (dialogContainer) {
                    dialogContainer.style.background = "linear-gradient(135deg, #030510, #040a1b)";
                    dialogContainer.style.border = "2px solid rgba(233, 69, 96, 0.4)";
                    dialogContainer.style.boxShadow = "0 20px 60px rgba(0, 0, 0, 0.6), 0 0 40px rgba(233, 69, 96, 0.4), inset 0 0 30px rgba(233, 69, 96, 0.1)";
                }
                if (dialogSurface) {
                    dialogSurface.style.background = "linear-gradient(135deg, #030510, #040a1b)";
                }
            } else {
                // Remove inline styles for non-gradient themes
                if (dialogContainer) {
                    dialogContainer.style.background = "";
                    dialogContainer.style.border = "";
                    dialogContainer.style.boxShadow = "";
                }
                if (dialogSurface) {
                    dialogSurface.style.background = "";
                }
            }

            console.log("Dialog theme updated:", themeValue, {
                hostElement: hostElement.classList.toString(),
                dialogContainer: dialogContainer?.classList.toString(),
                dialogSurface: dialogSurface?.classList.toString(),
                inlineStyles: themeValue === "2" ? "Applied" : "Removed",
            });

            this.cd.markForCheck();
        }, 0);
    }

    installPwa() {
        this.appService.installPwa();
    }

    openTwitter() {
        this.dialog.open(TwitterComponent, {
            height: "600px",
            width: "400px",
        });
    }

    async showReleaseNotesDialog() {
        this.appService.showReleaseNotes();
        const evt = await this.appService.checkAppVersion();
        if (evt && isHostDev()) {
            alert("found new SignStudio version " + evt);
            console.log("Found new version " + evt);
        }
    }

    checkNetwork() {
        this.dialog.open(this.networkStatusModal, {
            height: "430px",
            width: "800px",
        });
    }

    goToLink(link: string) {
        // throw new Error("testing random error..." + Math.random());
        let url;
        switch (link) {
            case "chat": {
                Lib.openLiveChat(true, this.user, this.appStatic, this.router);
                return;
            }
            case "forum": {
                url = this.appStatic.homePage.replace("www", "forum");
                break;
            }
            case "home": {
                this.appService.goToHomePage(true);
                return;
            }
        }
        popupWindow({ url, title: "_blank", w: 500, h: 500 });
    }

    onRouterClick(): void {
        this.routerClick.emit();
        // Trigger AI gradient line animation on nav click (gradient theme only)
        // Wait 1.5s for lazy-loaded module to finish loading before animating
        if (this.currentTheme === "2") {
            this.navLineAnimating = false;
            this.cd.detectChanges();
            setTimeout(() => {
                if ((this.cd as any)?.destroyed) return;
                this.navLineAnimating = true;
                this.cd.markForCheck();
            }, 1500);
        }
    }

    onRouterPromptClick(): void {
        this.routerClick.emit();
        // Trigger AI gradient line animation on nav click (gradient theme only)
        // Wait 1.5s for lazy-loaded module to finish loading before animating
        if (this.currentTheme === "2") {
            this.navLineAnimating = false;
            this.cd.detectChanges();
            setTimeout(() => {
                if ((this.cd as any)?.destroyed) return;
                this.navLineAnimating = true;
                this.cd.markForCheck();
            }, 1500);
        }
    }


    upgrade() {
        this.appService.openWizardUpgradeDialog(null, "800px", "800px", true, false, true);
    }

    goBack() {
        this.containerService.setMarkedTableRow(this.selectedSceneId);
        this.router.navigateByUrl("/editor/list");
    }

    openComponentsDialog(): void {
        this.dialogCompAddRef = this.dialog.open(SceneAddComponentDialog, {
            width: "90%",
            height: "90%",
            panelClass: "custom-dlg-container",
            data: { Component: "Add" },
        });
        this.dialogCompAddRef.afterClosed().subscribe(result => {
            if (result) {
            }
        });
    }


    onMinimized() {
        this.whenMinimized.emit();
        this.cd.detectChanges();
    }

    onMaximized() {
        this.whenMaximized.emit();
    }

    onExpandPanel(panel) {
        if (this.minimized) {
            this.whenMaximized.emit();
        }
        setTimeout(() => {   // setTimeOut is necessary as collapse and expand event are triggered at moment
            this.activePanel = panel;
            this.cd.detectChanges();
        }, 100);
    }

    onCollapsePanel() {
        this.activePanel = 0;
        this.cd.detectChanges();
    }

    onKeyDown(event) {
        if (event.key === "ArrowDown" || event.key === "ArrowUp") {
            // event.preventDefault(); // Prevent default scroll action
            // event.stopPropagation(); // Stop further propagation
            // event.stopImmediatePropagation();
            // document.getElementById('viewSceneContainer').focus();
            if (event.target) {
                event.target.focus();
            }
        }
    }
}

// if (this.dashboardMode) {
//     this.signStudioEvents$ = this.accessService.getGroupsCollection("SignStudio Events").pipe(map((a) => a && a.$.visible ? a.$.visible : '0'));
//     this.signStudioTransitions$ = this.accessService.getGroupsCollection("SignStudio Transitions").pipe(map((a) => a && a.$.visible ? a.$.visible : '0'));
//     this.signStudioAdnet$ = this.accessService.getGroupsCollection("SignStudio Adnet").pipe(map((a) => a && a.$.visible ? a.$.visible : '0'));
// } else {
//     this.signStudioEvents$ = this.accessService.getGroupsCollection("SignStudio Events").pipe(map((a) => a && a.$.visible ? a.$.visible : '0'));
//     this.signStudioTransitions$ = this.accessService.getGroupsCollection("SignStudio Transitions").pipe(map((a) => a && a.$.visible ? a.$.visible : '0'));
//     this.signStudioAdnet$ = this.accessService.getGroupsCollection("SignStudio Adnet").pipe(map((a) => a && a.$.visible ? a.$.visible : '0'));
// }
// this.$accessEditors = this.accessService.getGroupsCollection("Changelist").pipe(map((a) => a.$.visible));
// this.$accessEditors = this.accessService.getGroupsCollection("Campaigns").pipe(map((a) => a.$.visible));
// this.$accessEditors = this.accessService.getGroupsCollection("Changelist").pipe(map((a) => a.$.visible));


